import { combineReducers } from "@reduxjs/toolkit";
import emailTemplatesControlReducer from "./emailTemplatesControl";
import emailNotificationsControlReducer from "./emailNotificationsControl";
import sitemapControlReducer from "./sitemapControl";
import homePageCategoryControlReducer from "./homePageCategoryControl";
import lawControlReducer from "./lawControl";
import rolesControlReducer from "./rolesControl";
import groupsControlReducer from "./groupsControl";
import usersControlReducer from "./usersControl";
import globalMessageControlReducer from "./globalMessageControl";
import myAccountControl from "./myAccountControl";
import adminConsoleConfigControl from "./adminConsoleConfigControl";
import referenceDataControl from "./referenceDataControl";
import nationalUniversityControl from "./nationalUniversityControl";
import serviceDefinitionControlReducer from "./serviceDefinitionControl";
import homePageControlReducer from "./homePageControl";

const componentsControlReducers = combineReducers({
  emailTemplatesControl: emailTemplatesControlReducer,
  emailNotificationsControl: emailNotificationsControlReducer,
  sitemapControl: sitemapControlReducer,
  homePageCategoryControl: homePageCategoryControlReducer,
  lawControl: lawControlReducer,
  rolesControl: rolesControlReducer,
  groupsControl: groupsControlReducer,
  usersControl: usersControlReducer,
  globalMessageControl: globalMessageControlReducer,
  serviceDefinitionControl: serviceDefinitionControlReducer,
  myAccountControl: myAccountControl,
  acConfigControl: adminConsoleConfigControl,
  referenceDataControl: referenceDataControl,
  nationalUniversityControl: nationalUniversityControl,
  homePageControl: homePageControlReducer,
});

export default componentsControlReducers;
